import { CircularProgress } from "@material-ui/core";
import { Text } from "components/Typography/text.styled";
import { BannerComponent } from "components/banners/banner.component";
import {
  LoggedInPageContainer,
  LoggedOutPageContainer,
} from "components/pageLayouts/pageLayouts.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import { Analytics } from "web-apps/company/components/analytics/analytics.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

export const AnalyticsPage = () => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();

  return (
    <div>
      <LoggedInPageContainer>
        {authState.isLoading || companyState.isLoading ? (
          <LoggedOutPageContainer>
            <CircularProgress />
          </LoggedOutPageContainer>
        ) : (
          <LoggedInPageContainer>
            {companyState.company?.verified ? (
              <Analytics />
            ) : (
              <BannerComponent
                icon="clock"
                backgroundColor={Color.ChampagnePink}
                fill={Color.Destructive}
              >
                <Text
                  fontSize={FontSize.Large}
                  fontFamily={FontFamily.MontserratSemiBold}
                  color={Color.Destructive}
                >
                  {t("GigsCompany.UnverifiedAccount")}
                </Text>
                <Text>{t("GigsCompany.UnverifiedAccountDetails")}</Text>
              </BannerComponent>
            )}
          </LoggedInPageContainer>
        )}
      </LoggedInPageContainer>
    </div>
  );
};
